import { RosterTotalStatsV2 } from '@wwe-portal/ui/features/roster';
import { useSuperstarDetailContext } from './context';
import { NumberDiff } from '@wwe-portal/ui/components/text-diff';
import { StickyTopMenu } from '@wwe-portal/ui/components/navigation/stick-menu';
import { CompareVFXConsumer } from './compare-vfx';
import { ShowcaseTarget } from '@wwe-portal/ui/components/showcase/primitives';
import {
  SUPERSTAR_DETAILS_TUTORIAL_TARGET_IDS,
  SUPERSTAR_DETAILS_TUTORIAL_SHOWCASE_ID,
} from '@wwe-portal/web/utils/superstar-details/constants';

export const TotalStatsConsumer = () => {
  const { totalHP, totalTalent } = useSuperstarDetailContext((state) => ({
    totalHP: state.currentStats.totalHP,
    totalTalent: state.currentStats.totalTalent,
  }));
  const baseStats = useSuperstarDetailContext((state) => state.baseStats);

  return (
    <StickyTopMenu
      fluid={false}
      className="top-[128px] pb-0 pt-0 xl:top-[138px]"
    >
      <CompareVFXConsumer>
        <ShowcaseTarget
          showCaseId={SUPERSTAR_DETAILS_TUTORIAL_SHOWCASE_ID}
          targetId={SUPERSTAR_DETAILS_TUTORIAL_TARGET_IDS.TOTAL_SCORE}
        >
          <RosterTotalStatsV2
            totalScore={
              totalTalent != null ? (
                <NumberDiff
                  oldValue={baseStats?.totalTalent ?? totalTalent}
                  newValue={totalTalent}
                  showBaseDiff={false}
                />
              ) : null
            }
            totalHP={
              totalHP != null ? (
                <NumberDiff
                  oldValue={baseStats?.totalHP ?? totalHP}
                  newValue={totalHP}
                  showBaseDiff={false}
                />
              ) : null
            }
          />
        </ShowcaseTarget>
      </CompareVFXConsumer>
    </StickyTopMenu>
  );
};
